(function(jQuery) {
	'use strict';

	jQuery('.o-slider').each(function() {
    jQuery('.list', this).slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
      autoplay: true,
			appendDots: jQuery('.dots', this),
			prevArrow: jQuery('.arrow-prev', this),
			nextArrow: jQuery('.arrow-next', this),
    });
	});

})(jQuery);
